import script from "./Sidebarmenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sidebarmenu.vue?vue&type=script&setup=true&lang=ts"

import "./Sidebarmenu.vue?vue&type=style&index=0&id=6374c9d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6374c9d6"]])

export default __exports__